module.exports = function() {
  return new Worker(__webpack_public_path__ + "web-worker.c0147caea183dde406a3.js");
};